import React from 'react';
import styles from '../styles/footer.module.scss';

const Footer = () => (
  <footer className={styles.footer}>
    <hr />
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
      }}
    >
      <div style={{ marginRight: '8px', paddingTop: '8px' }}>
        © Mira's Maids - Home cleaning services
      </div>
      <div
        style={{ fontSize: '0.75rem', maxWidth: '250px', paddingTop: '8px' }}
      >
        Mira's Maids is the trading name for Kurti Corporations LTD (company no:
        14308147)
      </div>
    </div>
  </footer>
);

export default Footer;
